<!-- feedstock financials -->
<h1
  *ngIf="feedstocks && feedstocks.length > 0"
  anessaTranslation="PROJECT.FINANCIAL_FEEDSTOCK.FEED_FIN_INFO">
</h1>
<div *ngIf="feedstocks && feedstocks.length > 0" class="table-spacing">
  <anessa-table
    [data]="feedstocks"
    [keys]="['name']"
    [customFields]="getFeedstockPricingArray()"
    [translateCustomFields]="true"
    [customFieldsAreUnits]="true"
    [isRemoveActive]="false"
    [style]="'small'"
    [editIndex]="editFeedstockIndex"
    (onEdit)="onEditFeedstock($event)">
  </anessa-table>
</div>
<!-- generated product financials -->
<h1
  *ngIf="generatedProducts && generatedProducts.length > 0"
  anessaTranslation="PROJECT.FINANCIAL_GEN_PROD.GEN_PROD_FIN_INFO">
</h1>
<div *ngIf="generatedProducts && generatedProducts.length > 0" class="table-spacing">
  <anessa-table
    [data]="generatedProducts"
    [keys]="['name']"
    [customFields]="getGeneratedProductPricingArray()"
    [translateCustomFields]="true"
    [customFieldsAreUnits]="true"
    [isRemoveActive]="false"
    [style]="'small'"
    [editIndex]="editIndex"
    (onEdit)="onEditGeneratedProduct($event)">
  </anessa-table>
</div>
<!-- capital expenditures -->
<h1 anessaTranslation="PROJECT.FINANCIAL_CAPEX.CAPEX"></h1>
<div
  class="buttongroup top-button-group-spacer relative-container">
  <button
    mat-button
    class="btn-primary btn-compact flex-1"
    type="button"
    [disabled]="capex.length > 0"
    (click)="onAddCapexClick()"
    anessaTranslation="PROJECT.FINANCIAL_CAPEX.ADD_CAPEX">
  </button>
  <button
    mat-button
    class="btn-primary btn-compact flex-1"
    type="button"
    (click)="onEstimateCapexClick()"
    [matTooltip]="('PROJECT.FINANCIAL_CAPEX.ESTIM_WARNING' | anessaTranslation: trigger)"
    anessaTranslation="PROJECT.FINANCIAL_CAPEX.ESTIM_CAPEX"
  >
  </button>
  <app-confirmation-pop-up
    *ngIf="showCapexEstimationConfirmation"
    [confirmMessage]="('PROJECT.INITIAL.ESTIMATE_TOOLTIP. PROJECT.FINANCIAL_CAPEX.ESTIM_CONFIRM' | anessaTranslation: trigger)"
    (confirmed)="performCapexEstimation()"
    (rejected)="showCapexEstimationConfirmation = false"
    [positionBottom]="null"
    [positionLeft]="400"
  ></app-confirmation-pop-up>
</div>
<div class="table-spacing">
  <h3 class="top-space" anessaTranslation="PROJECT.FINANCIAL_CAPEX.ITEM_LIST"></h3>
  <div class="relative-container">
    <anessa-table
      [data]="capex"
      [keys]="['name']"
      [customFields]="getCapexPricingArray()"
      [translateCustomFields]="true"
      [customFieldsAreUnits]="true"
      (onEdit)="onEditCapex($event)"
      (onRemove)="onRemoveCapex($event)">
    </anessa-table>
  </div>
</div>
<div class="half-width">
  <h3 class="no-default-margin" anessaTranslation="PROJECT.FINANCIAL_CAPEX.TOTAL"></h3>
  <form>
    <app-unit-value
      [units]="'Currency'"
      [name]="'total-capex'"
      [enableConversions]="true"
      [disableValue]="true"
      [disableClear]="true"
      [(ngModel)]="totalCapex"
      (unitValueChange)="onTotalCapexChanged()">
    </app-unit-value>
  </form>
</div>
<div>
  <button
    mat-button
    class="btn-compact"
    (click)="clearAllCapex()"
    anessaTranslation="PROJECT.COMMON.CLEAR_ALL">
  </button>
</div>
<!-- operational expenditures -->
<h1 anessaTranslation="PROJECT.FINANCIAL_OPEX.OPEX"></h1>
<div class="buttongroup top-button-group-spacer relative-container">
  <button
    mat-button
    class="btn-primary btn-compact flex-1"
    type="button"
    [disabled]="opex.length > 0"
    (click)="onAddOpexClick()"
    anessaTranslation="PROJECT.FINANCIAL_OPEX.ADD_OPEX">
  </button>
  <button
    mat-button
    class="btn-primary btn-compact flex-1"
    type="button"
    (click)="onEstimateOpexClick()"
    [matTooltip]="('PROJECT.FINANCIAL_OPEX.ESTIM_WARNING' | anessaTranslation: trigger)"
    anessaTranslation="PROJECT.FINANCIAL_OPEX.ESTIM_OPEX">
  </button>
  <app-financial-opex-estimation-confirm
    *ngIf="showOpexEstimationConfirmation"
    (confirmed)="performOpexEstimation($event)"
    (rejected)="showOpexEstimationConfirmation = false"
    [positionBottom]="null"
    [positionLeft]="400"
  ></app-financial-opex-estimation-confirm>
</div>
<div class="table-spacing">
  <h3 anessaTranslation="PROJECT.FINANCIAL_OPEX.ITEM_LIST"></h3>
  <div class="relative-container">
    <anessa-table
      [data]="opex"
      [keys]="['name']"
      [customFields]="getOpexPricingArray()"
      [translateCustomFields]="true"
      [customFieldsAreUnits]="true"
      (onEdit)="onEditOpex($event)"
      (onRemove)="onRemoveOpex($event)">
    </anessa-table>
  </div>
</div>
<h3 class="no-default-margin">
  {{'PROJECT.FINANCIAL_OPEX.TOTAL_CAPEX' | anessaTranslation: trigger}} {{ getOpexPercentageString() }}
</h3>
<div class="half-width">
  <form>
    <app-unit-value
      [units]="'Currency'"
      [name]="'total-opex'"
      [enableConversions]="true"
      [disableValue]="true"
      [disableClear]="true"
      [(ngModel)]="totalOpex"
      (unitValueChange)="onTotalOpexChanged()">
    </app-unit-value>
  </form>
</div>
<div>
  <button
    mat-button
    class="btn-compact"
    (click)="clearAllOpex()"
    anessaTranslation="PROJECT.COMMON.CLEAR_ALL">
  </button>
</div>
